<div class="img">
    <img src="assets/images/logo/logo.png" width="370px">
</div>
<h3 class="text-center">Confirmation du compte</h3>
<p class="confirmation text-center" *ngIf="loading">Confiramtion <span>.</span><span>.</span><span>.</span></p>
<div class="bag">
    <div class="confirmation-success" *ngIf="confirme">
        <div class="f-modal-alert">
            <div class="f-modal-icon f-modal-success animate">
                <span class="f-modal-line f-modal-tip animateSuccessTip"></span>
                <span class="f-modal-line f-modal-long animateSuccessLong"></span>
                <div class="f-modal-placeholder"></div>
                <div class="f-modal-fix"></div>
            </div>
        </div>
        <p class="text-center">
            Merci, Votre compte a été bien confirmé.
        </p>
        <a href="javascript:void(0)" class="add-to-cart btn" (click)="goToCarte()">
            <i class="flaticon-shopping"></i>
            <span>Commander</span>
        </a>
    </div>
    <div class="confirmation-success" *ngIf="aleardyConfirmed">
        <div class="f-modal-alert">
            <div class="f-modal-icon f-modal-success animate">
                <span class="f-modal-line f-modal-tip animateSuccessTip"></span>
                <span class="f-modal-line f-modal-long animateSuccessLong"></span>
                <div class="f-modal-placeholder"></div>
                <div class="f-modal-fix"></div>
            </div>
        </div>
        <p class="text-center">
            Merci, Votre compte a été déjà confirmé.
        </p>
        <a href="javascript:void(0)" class="add-to-cart btn" (click)="goToCarte()">
            <i class="flaticon-shopping"></i>
            <span>Commander</span>
        </a>

    </div>
    <div class="error" *ngIf="error">
        Opps, Une erreur s'est produite. Veuillez réessayer plus tard.
    </div>
</div>